export enum QueryParamsChangeType {
  FOR_SALE = 'forSale',
  MULTI_SELECT = 'multiSelect',
  RANGE_FILTER = 'rangeFilter',
  MAC_FOLDERS = 'macFolders',
  PRIVATE_PORTAL = 'privatePortal'
}